import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { Status } from 'src/app/core/framework/default.model';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { InterceptorPreLogin } from 'src/app/core/framework/http-interceptor-prelogin';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { IPoliticaDePrivacidadeFilter } from './model/politica-de-privacidade.filter';
import { PoliticaDePrivacidade } from './model/politica-de-privacidade.model';

@Injectable({
  providedIn: 'root'
})
export class PoliticaDePrivacidadeService extends DefaultService<PoliticaDePrivacidade> {

  static URL = '/api/politicadeprivacidade/v1/politicaDePrivacidade';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandlerService,
      PoliticaDePrivacidadeService.URL
    )
  }

  buscarPoliticaAtiva(): Observable<PoliticaDePrivacidade> {
    const filtro: IPoliticaDePrivacidadeFilter = {
      status: Status.ATIVO,
      sort: ['dataAlteracao,desc'],
      size: 1
    };
    const params = DefaultService.converterFiltroParaHttpParam(filtro);
    params.append(InterceptorPreLogin, '');

    const httpOptions = {
      headers: new HttpHeaders({}).append(InterceptorPreLogin, ''),
      params: params
    };

    return this.httpClient
               .get<ListaResultset<PoliticaDePrivacidade>>(PoliticaDePrivacidadeService.URL, httpOptions)
               .pipe(
                  map((politicas: ListaResultset<PoliticaDePrivacidade>) => {
                    if ( politicas.content.length > 0 ) {
                      return politicas.content[0];
                    }
                      
                    return null;
                  })
                  , catchError( err => throwError(this.errorHandlerService.handle(err)) )
                );
  }
}
